/** Animations the respondent screens use — also mounted by the wizard's
 *  live preview, which renders these same screens inside a phone frame. */
export const RESPONDENT_KEYFRAMES = {
  '@keyframes recPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(234,80,72,.55)' },
    '70%': { boxShadow: '0 0 0 8px rgba(234,80,72,0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(234,80,72,0)' },
  },
  '@keyframes countPop': {
    '0%': { transform: 'scale(.55)', opacity: 0 },
    '25%': { transform: 'scale(1.08)', opacity: 1 },
    '100%': { transform: 'scale(1)', opacity: 1 },
  },
}
